export const theme = {
  colors: {
    primary: '#333F50',
    trueWhite: '#FFFFFF',
    white: '#F1EFEF',
    background: '#F1EFEFE5',
    black: '#191D24',
    success: '#46B285',
    error: '#e74c3c',
    alert: '#f9ca24',
    normal: '#4673B2',
    border: '#BBBBBB',
    shadow: '#00000070',
    darkPrimary: '#212935',
    darkSuccess: '#3A946E',
    darkAlert: '#DFB007',
    darkError: '#CC3525',
    darkNormal: '#395D91'
  },
  border: '1px solid #BBBBBB',
  borderRadius: {
    small: '5px',
    normal: '10px'
  },
  fonts: {
    size: {
      superSmall: '12px',
      small: '14px',
      normal: '14px',
      big: '18px',
      superBig: '24px',
      extraBig: '36px'
    },
    weight: {
      thin: '300',
      normal: '400',
      bold: '500',
      superBold: '700'
    }
  }
} as const
